"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'slate',
    name: 'Slate',
    background_color: '#333333',
    background_image: null,
    background_image_portrait: null,
    heading_font: 'https://fonts.raydiant.com/Raleway-Bold.woff',
    heading_text_color: '#ffad0a',
    heading_2_font: null,
    heading_2_text_color: null,
    body_font: 'https://fonts.raydiant.com/Raleway-Regular.woff',
    body_text_color: '#ffffff',
    border_color: null,
};
//# sourceMappingURL=slate.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/slate.js